<style>
    .v-settings-menu .v-settings-menu-item {
        cursor: pointer;
    }

    .v-settings-menu .v-settings-menu-item:hover {
    }
</style>


<template>
    <div class="animated fadeIn v-settings-menu">
        <b-row>
            <b-col v-if="false" lg="4" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/support/documentations'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-files-o font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Guides et documentations')}}</h5>
                        <small>{{Core.Definition.getDefinition('Consulter la documentation et les guides d\'utilisation de Perfoplanning')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="4" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/support/billets'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-edit font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Support aux utilisateurs')}}</h5>
                        <small>{{Core.Definition.getDefinition('Voir ou créer un billet de support')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col v-if="false" lg="4" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/support/pipelines'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-calendar-o font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Pipeline de développement')}}</h5>
                        <small>{{Core.Definition.getDefinition('Soyez informé sur nos fonctionnalités à venir')}}</small>
                    </div>
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))

    export default {
        name: 'SupportMenu',
        components: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
